import { UserRole } from '@/hooks/useUserRole';

export type Role = 'guest' | 'verified' | 'greencheck' | 'moderator' | 'admin';

export interface Session {
  role: Role;
  isAuthenticated: boolean;
  roles: UserRole[];
  community_key?: string;
  modsOf?: string[];
}

// Map Supabase auth state to our role system
export const mapToRole = (isAuthenticated: boolean, roles: UserRole[]): Role => {
  if (!isAuthenticated) return 'guest';
  if (roles.includes('admin')) return 'admin';
  if (roles.includes('moderator')) return 'moderator';
  // For now, treat all authenticated users as 'verified'
  // 'greencheck' can be implemented later with a verified_users table
  return 'verified';
};

// Permission checks
export const canCompose = (s: Session) => s.role !== 'guest';

export const canListMarketplace = (s: Session) => 
  s.role === 'greencheck' || s.role === 'moderator' || s.role === 'admin';

export const canCreateEvent = canListMarketplace;

export const canModerate = (s: Session, ck: string) =>
  (s.role === 'moderator' && s.modsOf?.includes(ck)) || s.role === 'admin';

// Reason codes for redirects
export type ReasonCode = 
  | 'auth_required' 
  | 'green_check_required' 
  | 'mod_scope_required' 
  | 'forbidden';

export const getReasonMessage = (code: ReasonCode): string => {
  switch (code) {
    case 'auth_required':
      return 'You must be signed in to access this page.';
    case 'green_check_required':
      return 'This feature requires Green Check verification. Please verify your account.';
    case 'mod_scope_required':
      return 'This page requires moderator privileges for the specified community.';
    case 'forbidden':
      return 'You do not have permission to access this resource.';
  }
};
